<div class="row pb-2" [ngClass]="{'justify-content-end': justifyContentRight}">
  <div class="col-12 ps-4">
    <nb-radio-group
      name="budgetOrRatioCarbonFilter"
      class="filters-container"
      [(ngModel)]="budgetOrRatioCarbonFilter"
      (click)="budgetOrRatioFilterChanged()"
      >
      @for (option of budgetOrRatioCarbonFilterOptions; track option) {
        <nb-radio [value]="option.value">
          {{ option.label }}
        </nb-radio>
      }
    </nb-radio-group>
  </div>
</div>
